import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SimpleDialogComponent } from './simple-dialog.component'

@NgModule({
    declarations: [SimpleDialogComponent],
    exports: [SimpleDialogComponent],
    imports: [CommonModule],
})
export class SimpleDialogModule {}
